
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalEast as ObiBuoyConicalEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-east.js';
 
 
 

 
 export const ObiBuoyConicalEast = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-east',
   elementClass: ObiBuoyConicalEastElement,
   events: {
     
   }
  });
 
 